import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { SelectedButton } from "@/components/filters/ToggleButton/SelectedButton";
import { MDSButton, MDSButtonIcon, MDSButtonSlotName } from "@/mds";
import styled from "@emotion/styled";

interface IProps {
  hasSelectedItems: boolean;
  computedButtonLabel: string;
  setIsOpen: (isOpen: boolean) => void;
  onClear: () => void;
  iconKind?: MdsIconKind;
}

export function ToggleButton({
  hasSelectedItems,
  computedButtonLabel,
  setIsOpen,
  onClear,
  iconKind = MdsIconKind.User,
}: IProps) {
  return (
    <StyledToggleButton $hasSelectedItems={hasSelectedItems} onClick={() => setIsOpen(true)}>
      {iconKind && <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={iconKind} />}
      {computedButtonLabel}
      <div slot={MDSButtonSlotName.RightIcon}>
        {hasSelectedItems ? (
          <SelectedButton onSelectClear={onClear} />
        ) : (
          <MdsIcon kind={MdsIconKind.AngleDown} />
        )}
      </div>
    </StyledToggleButton>
  );
}

const StyledToggleButton = styled(MDSButton)<{ $hasSelectedItems: boolean }>`
  height: auto;
  padding: ${({ theme }) => theme.spacing["2"]} ${({ theme }) => theme.spacing["3"]};
  color: ${({ theme, $hasSelectedItems }) =>
    $hasSelectedItems ? theme.colors.text.emphasis : theme.colors.text.tertiary};

  border: none;

  background-color: ${({ theme, $hasSelectedItems }) =>
    $hasSelectedItems
      ? theme.colors.background.button.toggle.toggled
      : theme.colors.background.button.toggle.default};

  &[data-hovered]:not([data-disabled]) {
    background-color: ${({ theme, $hasSelectedItems }) =>
      $hasSelectedItems
        ? theme.colors.background.button.toggle.toggledHover
        : theme.colors.background.button.toggle.hover};
  }

  & .mds-icon {
    color: ${({ theme, $hasSelectedItems }) =>
      $hasSelectedItems ? theme.colors.icon.selected : theme.colors.icon.placeholder};
  }
`;
